import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import LargeTitle from '../../atoms/LargeTitle/LargeTitle'
import TextLabel, { SizeType, WeightType } from '../../atoms/TextLabel/TextLabel'
import Image from '../../atoms/Image/Image'
import QRCode from '../../atoms/QRCode/QRCode'
import ParticipantCounter from '../../molecules/ParticipantCounter/ParticipantCounter'

import './PresentationTitle.css'

const PresentationTitle = ({ participantCount, title, image, shareUrl }) => (
  <div styleName="container">
    <div styleName="l-information">
      <div styleName="l-title">
        <LargeTitle size={SizeType.SMALL} weight={WeightType.HEAVY}>
          {title}
        </LargeTitle>
      </div>
      <div styleName="l-count">
        <ParticipantCounter count={participantCount} />
      </div>
      <div>{shareUrl ? <QRCode url={shareUrl} size={200} /> : null}</div>
      <div />
      <div styleName="l-notice">
        <TextLabel size={SizeType.TINY} weight={WeightType.HEAVY}>
          参加はこちらのQRコードから
        </TextLabel>
      </div>
    </div>
    <div styleName="l-image">
      <Image src={image} isRadius={false} />
    </div>
  </div>
)

PresentationTitle.propTypes = {
  participantCount: PropTypes.number,
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  shareUrl: PropTypes.string
}

export default compose(pure)(PresentationTitle)
